import { render, staticRenderFns } from "./AppHero.vue?vue&type=template&id=1ca35987&"
import script from "./AppHero.vue?vue&type=script&lang=js&"
export * from "./AppHero.vue?vue&type=script&lang=js&"
import style0 from "./AppHero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports